import { Button } from '@mui/material';
import React, { forwardRef } from 'react';

const CustomButton = forwardRef((props, ref) => {
  const {
    type,
    variant,
    children,
    disabled,
    color,
    onClick,
    sx,
    style,
    size = 'small',
    ...restProps
  } = props;

  return (
    <Button
      type={type || 'button'}
      ref={ref}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      color={color || 'generalButton'}
      sx={sx}
      style={style}
      size={size}
      {...restProps}
    >
      {children}
    </Button>
  );
});

export default CustomButton;
